import React, { Fragment } from "react";
import Tab from "react-bootstrap/Tab";
import Nav from "react-bootstrap/Nav";
import { constructArtificialLinkNode, getStaticPageLink } from "../../../utils/links";
import Breadcrumb from "../../../components/magnolia/breadcrumb/Breadcrumb";
import HtmlHeader from "../../../components/magnolia/htmlHeader/HtmlHeader";
import LinkWrapper from "../../../components/magnolia/linkWrapper/LinkWrapper";

// Magnolia twin of flone's pages/other/LoginRegister (demo forms, nothing is submitted). It
// renders inside BaseLayout, which already provides the shop's header and footer, so there is
// no LayoutOne here (that gave the page a second, flone-branded header).
const LoginRegister = () => {
    return (
        <Fragment>
            <HtmlHeader title="Login" />
            <Breadcrumb />

            <div className="login-register-area pt-100 pb-100">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-7 col-md-12 ms-auto me-auto">
                            <div className="login-register-wrapper">
                                <Tab.Container defaultActiveKey="login">
                                    <Nav variant="pills" className="login-register-tab-list">
                                        <Nav.Item>
                                            <Nav.Link eventKey="login">
                                                <h4>Login</h4>
                                            </Nav.Link>
                                        </Nav.Item>
                                        <Nav.Item>
                                            <Nav.Link eventKey="register">
                                                <h4>Register</h4>
                                            </Nav.Link>
                                        </Nav.Item>
                                    </Nav>
                                    <Tab.Content>
                                        <Tab.Pane eventKey="login">
                                            <div className="login-form-container">
                                                <div className="login-register-form">
                                                    <form>
                                                        <input type="text" name="user-name" placeholder="Username" />
                                                        <input type="password" name="user-password" placeholder="Password" />
                                                        <div className="button-box">
                                                            <div className="login-toggle-btn">
                                                                <input type="checkbox" />
                                                                <label className="ms-10">Remember me</label>
                                                                <LinkWrapper linkNode={constructArtificialLinkNode({ value: getStaticPageLink("HOME") })}>
                                                                    Forgot Password?
                                                                </LinkWrapper>
                                                            </div>
                                                            <button type="submit">
                                                                <span>Login</span>
                                                            </button>
                                                        </div>
                                                    </form>
                                                </div>
                                            </div>
                                        </Tab.Pane>
                                        <Tab.Pane eventKey="register">
                                            <div className="login-form-container">
                                                <div className="login-register-form">
                                                    <form>
                                                        <input type="text" name="user-name" placeholder="Username" />
                                                        <input type="password" name="user-password" placeholder="Password" />
                                                        <input name="user-email" placeholder="Email" type="email" />
                                                        <div className="button-box">
                                                            <button type="submit">
                                                                <span>Register</span>
                                                            </button>
                                                        </div>
                                                    </form>
                                                </div>
                                            </div>
                                        </Tab.Pane>
                                    </Tab.Content>
                                </Tab.Container>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </Fragment>
    );
};

export default LoginRegister;